/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { B as Button, d as defineCustomElement$1 } from './p-DK2Bn1Mc.js';

const IonButton = Button;
const defineCustomElement = defineCustomElement$1;

export { IonButton, defineCustomElement };
